import i18n from "l10n";
import Backbone from "backboneAdapter";
import dhtmlx from "dhtmlxAdapter";
import moment from "moment";
import "moment-timezone";
import Handlebars from "handlebars";

// language=HTML
const template =
    '<div class="no-margin no-padding clearfix">\n' +
    '    <div class="grid">\n' +
    '        <div class="row">\n' +
    '            <div id="customer-information" class="span6 offset4" style="cursor:default; margin-top:30%;">\n' +
    '                <div class="text-center prompt" style="cursor:default;font-weight:100;">{{t "registrationconfirmation"}}</div>\n' +
    '                <div class="text-center">\n' +
    '                    <button id="agree-button" class="offset2 success margin15" style="min-width:70px;">{{t "agree"}}</button>\n' +
    '                    <button id="disagree-button" class="danger margin15"  style="min-width:70px;">{{t "disagree"}}</button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <h1 class="col-lg-offset-6">\n' +
    '                <i id="spinner" class="icon-loading spin fg-funkyOrange header" style="display: none"></i>\n' +
    '            </h1>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div class=" text-center" style="margin-top:15%; margin-bottom:1%;">\n' +
    '    <a href="http://www.tellody.com">\n' +
    '        <img src="/CampaignCloud/resources/images/logo.png" alt="tellody" class="tellodyiconsize">\n' +
    '    </a>\n' +
    '</div>';

const ConfirmRegistrationView = Backbone.View.extend({
    template: Handlebars.compile(template),
    el: '#page-main-content',
    events: {
        "click #agree-button": "agree",
        "click #disagree-button": "disagree"
    },

    initialize: function (opts) {
        if (opts.provider) this.provider = opts.provider;
        this.render();
        this.$('[data-i18n]').i18n();
    },
    render() {
        this.$el.html(this.template());
    },
    agree: async function () {
        var self = this;
        self.url = '/CampaignCloud/PreAuthentication/userSchemaCreationConfirmed';
        try {
            let response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/oauthClient/continueRegistration',
                type: 'GET',
                dataType: "json"
            });
            if (response.status === "success") {
                let jqXHR = $.ajax({
                    url: '/CampaignCloud/RememberMeController/ping',
                    type: 'GET',
                    dataType: "json"
                });
                try {
                    await jqXHR;
                } finally {
                    window.csrf = jqXHR.getResponseHeader('X-CSRF-TOKEN');
                    await self.query();
                }
            } else {
                throw "failed on /continueRegistration";
            }
        } catch (e) {
            console.error(e);
            dhtmlx.alert(i18n.t('login.registrationerror'));
        }
    },
    query: async function () {
        let self = this;
        try {
            let response = await $.ajaxDefaultQ({
                url: self.url,
                type: 'POST',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-TZ-Offset', -(new Date()).getTimezoneOffset());
                    xhr.setRequestHeader('X-TZ-Name', moment.tz.guess());
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                },
                dataType: "json"
            });

            console.info(response);
            var preAuthenticateUsername = response.pre_authenticated_username;
            console.info(preAuthenticateUsername);
            var formValues = {
                username: preAuthenticateUsername
            };
            $('#agree-button').attr('disabled', true);
            $('#disagree-button').attr('disabled', true);
            if (response.status === 'success') {
                if (response.synchronous === 'true') {
                    self.afterAgreement();
                }
                else {
                    self.isTenantSchemaCreationCompleted(formValues);
                }
            } else if (response.status === 'fail') {
                console.info(response);
                dhtmlx.alert(i18n.t("register.registrationservererror"));
                this.trigger("navigation", "");
            }
        } catch (e) {
            console.info(e);
            dhtmlx.alert(i18n.t("register.registrationservererror"));
            this.trigger("navigation", "");
        }
    },
    isTenantSchemaCreationCompleted(formValues) {
        let self = this;
        $.ajaxDefaultQ({
            type: "POST",
            url: "/CampaignCloud/Registration/tenantSchemaCreationCompleted",
            dataType: "json",
            data: formValues,
            success: function (data) {
                if (data.schema_creation_status === 'completed') {
                    self.afterAgreement();
                } else {
                    $("#spinner").show();
                    $("#spaceship").show();
                    $('#agree-button').attr('disabled', true);
                    $('#disagree-button').attr('disabled', true);
                    setTimeout(function () {
                        self.isTenantSchemaCreationCompleted(formValues);
                    }, 10000);
                }
            },
            error: function () {
                setTimeout(function () {
                    self.isTenantSchemaCreationCompleted(formValues);
                }, 5000);
            }
        });
    },
    async afterAgreement() {
        $("body").removeClass("loading");
        $.ajaxDefaultQ({
            type: "POST",
            url: "/CampaignCloud/PreAuthentication/geolocationService",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-TZ-Offset', -(new Date()).getTimezoneOffset());
                xhr.setRequestHeader('X-TZ-Name', moment.tz.guess());
                xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
            },
            dataType: "json"
        }).always(function (response) {
            console.info(response);
        });

        var providerNames = ["google", "yahoo", "hotmail", "facebook"];
        var provider = this.provider;
        var providerId = providerNames.indexOf(provider.toLowerCase());

        if (providerId >= 0 && providerId <= 2) {
            const agreeToImport = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("contacts.agreetoimportcontacts", {provider: providerNames[providerId]}),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });
            if (agreeToImport) {
                var url = '/CampaignCloud/oauthClient/startAuthentication';
                var formValues = {
                    provider: providerId,
                    state: 'importContacts'
                };
                console.info(formValues);
                try {
                    let {status, LocationUri} = await $.ajaxDefaultQ({
                        url: url,
                        type: 'POST',
                        dataType: "json",
                        data: formValues
                    });
                    if (status === 'success') {
                        console.info(LocationUri);
                        window.open(LocationUri, '_self');
                    } else if (status === 'fail') {
                        dhtmlx.alert(i18n.t("login.registrationerror"));
                    }
                } catch (e) {
                    console.info(e);
                }
            } else {
                window.open('Dashboard.htm', '_self');
            }
        } else {
            window.open('Dashboard.htm', '_self');
        }
    },
    disagree: function () {
        this.trigger("navigation", "");
    }
});

export {ConfirmRegistrationView as default};